import { ServiceTimeoutError } from './error-handling';
import { getFetchWithTracing } from './setup';
import { getAuthorizationHeader } from './utils/auth';
import { startServiceTimeout } from './utils/timeout';
const defaultServiceTimeout = 10000;
export function getFetchOptions(serviceOptions = {}, mockConfig = {}) {
    const timeout = serviceOptions.timeout || defaultServiceTimeout;
    const headers = {};
    const authorizationHeader = getAuthorizationHeader(serviceOptions, mockConfig);
    if (authorizationHeader) {
        headers.Authorization = authorizationHeader;
    }
    const availableHeaders = serviceOptions.headers;
    if (availableHeaders) {
        Object.keys(availableHeaders).forEach((header) => {
            headers[header] = availableHeaders[header];
        });
    }
    return { headers, timeout };
}
function isNodeFetchRequestTimeoutError(error) {
    return error.type === 'request-timeout';
}
function isNetworkTimeoutError(error) {
    if (isNodeFetchRequestTimeoutError(error)) {
        return true;
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
    return error instanceof TypeError;
}
async function startFetching(url, options, serviceName) {
    try {
        const fetchFn = getFetchWithTracing(serviceName);
        return await fetchFn(url, options);
    }
    catch (error) {
        if (isNetworkTimeoutError(error)) {
            throw new ServiceTimeoutError(serviceName);
        }
        throw error;
    }
}
export async function fetch(url, serviceName, options = {}) {
    // tslint:disable-next-line strict-type-predicates
    if (typeof document !== 'undefined' && options.timeout) {
        return Promise.race([
            startFetching(url, options, serviceName),
            startServiceTimeout(options.timeout, serviceName),
        ]);
    }
    return startFetching(url, options, serviceName);
}
